import { StreamChat, Channel } from "stream-chat"
import { t } from "i18next"

import { streamUnreadStore } from "@stores/streamUnreadStore"

// @ts-expect-error Set up by stream.blade.php
export const streamSettings = window.streamSettings as {
	apiKey: string
	user: {
		id: string
		name: string
		token: string
		image: string | null
	} | null
}

export const streamClient = StreamChat.getInstance(streamSettings.apiKey)

if (streamClient && streamSettings.user) {
	streamClient
		.connectUser(
			{
				id: streamSettings.user.id,
				name: streamSettings.user.name,
				image: streamSettings.user.image || undefined,
			},
			streamSettings.user.token,
		)
		.then((user) => {
			// Once the user is connected, set up unread tracking
			if (user?.me) {
				streamUnreadStore.init(
					user.me.total_unread_count,
					user.me.unread_channels,
				)
			}
		})
}

const leaveChannel = async (channel: Channel) => {
	try {
		if (!streamSettings.user) {
			throw new Error(t("util.streamClient.streamNotInitialized"))
		}

		await channel.removeMembers([streamSettings.user.id], {
			text: `${streamSettings.user.name} left the channel`,
		})
	} catch (err) {
		console.error(t("util.streamClient.failedToLeaveChannel"), err)
		throw err
	}
}

export const confirmAndLeaveChannel = async (
	channel: Channel,
): Promise<boolean> => {
	// Check if channel has exactly 2 members before allowing leave
	const memberCount = Object.keys(channel.state.members).length
	const isAllPortalUsers =
		Object.values(channel.state.members).find((m) => {
			return m.user_id?.startsWith("U-")
		}) === undefined

	if (memberCount === 2 && !isAllPortalUsers) {
		alert(t("util.streamClient.cannotLeaveDesignerAlone"))
		return false
	}

	if (!confirm(t("util.streamClient.confirmLeaveChannel"))) {
		return false
	}

	await leaveChannel(channel)
	return true
}
